<template>
  <button
    class="control-button"
    @click="player.togglePanel(PanelType.TRANSCRIPT)"
    :aria-label="t('player.controls.transcript')"
    :data-tooltip="t('player.controls.transcript')"
    :aria-expanded="player.activePanel.value === PanelType.TRANSCRIPT"
    v-html="transcriptIcon"
  />
</template>

<script setup lang="ts">
import { transcriptIcon } from '../../assets/icons'
import { PanelType } from '../../types'
import { useVideoI18n } from '../../i18n'
import type { UseVideoPlayerReturn } from '../../composables/useVideoPlayer'

defineProps<{
  player: UseVideoPlayerReturn
}>()

const { t } = useVideoI18n()
</script>

<style scoped>
/* Styles are in main.scss */
</style>
